import { isEmbedded } from "@/Utils/superops/embedDetection";
import { ZomentumRoutes } from "@/Contracts";
import { getAppPathname } from "@/Utils/routing/getAppPathname";
import { SuperOpsSdkService } from "../services/SuperOpsSdkService";

export const resolveEmbeddedDocumentBackRoute = (): string | null => {
	if (!isEmbedded()) {
		return null;
	}
	if (SuperOpsSdkService.getHostWidgetName() !== "Opportunities") {
		return null;
	}
	const appPathname = getAppPathname();
	if (
		appPathname !== "/documents" &&
		!appPathname.startsWith("/documents/")
	) {
		return null;
	}
	return ZomentumRoutes.OpportunityList;
};
